import settingsTemplate from './settings.html';

export default angular
  .module('main.organizations.edit.tabs.settings', [])

  .directive('editOrganizationSettingsTab', () => {
    return {
      restrict: 'E',
      template: settingsTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   $timeout,
                   utils,
                   config,
                   ToastsService,
                   UsersService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');

        const ORGANIZATION_AVANTGUARD_DND_PROPERTY = 'AgDnd';
        const ORGANIZATION_USER_TAGS_PROPERTY = 'tags';
        const ORGANIZATION_LOCATION_TAGS_PROPERTY = 'locationTags';
        const ORGANIZATION_SIM_CARD_ACTIVATION_PROPERTY = 'SimCard';
        const ORGANIZATION_PROPERTIES = [
          'websiteDirectUrl',
        ];

        // Features form validation rules
        const formValidationRules = {
          'w': {
            fields: [
              {
                name: 'websiteDirectUrl',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.orgs.websiteDirectUrl.empty')
                  }, {
                    type: 'url',
                    prompt: $t('prompt.orgs.websiteDirectUrl.url')
                  }
                ]
              }
            ]
          }
        };

        $scope.orgSimCardOptions = [
          {
            id: '0',
            name: 'orgs.edit.settings.orgSimCardActivation.0',
          },
          {
            id: '1',
            name: 'orgs.edit.settings.orgSimCardActivation.1'
          }
        ];

        $('#form-features').form({
          inline: true,
          keyboardShortcuts: false
        });

        $scope.featureList = config.getConfigByKey('features');
        $scope.callCenterAgDndValues = [
          {
            id: '1',
            name: 'callCenter.agDnd-disabled',
            color: 'grey'
          },
          {
            id: '0',
            name: 'callCenter.agDnd-enabled',
            color: 'green'
          }
        ];

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          helpers: {},
          toggleFeature: toggleFeature,
          checkFeature: checkFeature,
          onCancelButtonClick: $scope.dataProvider.goBack,
          saveSettings: saveSettings,
          goToObjects: goToObjects,
          showAdvancedSettings: false,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationPropsResource.init(),
            $scope.dataProvider.parentOrganizationResource.init(),
            $scope.dataProvider.deviceTypesResource.init(),
            $scope.dataProvider.popularTagsResource.init(),
            $scope.dataProvider.canIEditAdvancedSettings.init(),
          ])
            .then(() => {
              initOrganizationSettingsModel();
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initOrganizationSettingsModel() {
          $scope.organization = angular.copy($scope.dataProvider.organizationResource.value);
          $scope.properties = angular.copy($scope.dataProvider.organizationPropsResource.value || []);
          $scope.parentOrgInfo = angular.copy($scope.dataProvider.parentOrganizationResource.value);
          $scope.popularTags = angular.copy($scope.dataProvider.popularTagsResource.value);

          $scope.showAdvancedSettings = $scope.dataProvider.canIEditAdvancedSettings.value || false;

          // Identify organization allowed device types
          $scope.deviceTypes = utils.getOrgAllowedDeviceTypes($scope.dataProvider.deviceTypesResource.value, $scope.organization, $scope.parentOrgInfo);
          $scope.orgDeviceTypeIds = $scope.organization.deviceTypes || '';
          $scope.helpers.selectedDeviceTypeIds = $scope.orgDeviceTypeIds.split(',');

          initOrgProperties();
        }

        function initOrgProperties() {
          $scope.helpers.selectedUserTags = [];
          $scope.helpers.selectedLocationTags = [];

          ORGANIZATION_PROPERTIES.forEach(propName => {
            let property = $scope.properties.find(el => el.name === propName);
            $scope.helpers[propName] = property ? property.value : '';
          });

          // Pass the rest of organization props into helpers
          for (let i = 0; i < $scope.properties.length; i++) {
            let property = $scope.properties[i];
            if (property) {
              switch (property.name) {
                case ORGANIZATION_AVANTGUARD_DND_PROPERTY:
                  $scope.helpers.agDnd = property.value ? property.value : '0';
                  break;
                case ORGANIZATION_USER_TAGS_PROPERTY:
                  if (property.value) {
                    $scope.helpers.selectedUserTags = property.value.split(',');
                  }
                  break;
                case ORGANIZATION_LOCATION_TAGS_PROPERTY:
                  if (property.value) {
                    $scope.helpers.selectedLocationTags = property.value.split(',');
                  }
                  break;
                case ORGANIZATION_SIM_CARD_ACTIVATION_PROPERTY:
                  if (property.value) {
                    $scope.helpers.orgSimCard = (property.value && property.value === '1') ? '1' : '0';
                  }
                  break;
              }
            }
          }

          initWatchers();
        }

        function initWatchers() {
          $scope.$watch('organization.features', function(newValue, oldValue) {
            if (!$scope.organization.features) {
              return;
            }
            for (let i = 0; i < $scope.featureList.length; i++) {
              let f = $scope.featureList[i];
              f.checked = $scope.organization.features.indexOf(f.id) !== -1;
              if (newValue !== oldValue) {
                evaluateFormValidation(f.id, f.checked);
              }
            }
          });

          $scope.$watchGroup(['organization', 'parentOrgInfo'], function() {
            if (!$scope.organization || !$scope.parentOrgInfo) {
              return;
            }

            for (let i = 0; i < $scope.featureList.length; i++) {
              let f = $scope.featureList[i];
              f.disabled = !showFeature(f.id);
            }
          });
        }

        function toggleFeature(feature) {
          if (formValidationRules[feature.id]) {
            if (feature.checked) {
              addValidationRules(formValidationRules[feature.id].fields);
            } else {
              removeValidationRules(formValidationRules[feature.id].fields);
            }
          }
        }

        function showFeature(f) {
          if ($scope.isParentLevel) { // parent organization level
            return true;
          }
          let features = ($scope.parentOrgInfo && $scope.parentOrgInfo.features) || '';
          return features.indexOf(f) !== -1;
        }

        /**
         * Test and evaluate form validatin rules
         */
        function evaluateFormValidation(feature, enabled) {
          if (formValidationRules[feature]) {
            if (enabled) {
              addValidationRules(formValidationRules[feature].fields);
            } else {
              removeValidationRules(formValidationRules[feature].fields);
            }
          }
        }

        function addValidationRules(fields) {
          if (fields && fields.length > 0) {
            fields.forEach(field => {
              //console.log('Adding rules for field = ' + field.name);
              $('#form-features').form('add rule', field.name, {
                rules: field.rules
              });
            });
          }
        }

        function removeValidationRules(fields) {
          if (fields && fields.length > 0) {
            let data = [];
            fields.forEach(field => {

              // Test if rules already there
              let element = $('#form-features').form('get field', field.name);
              let test = $('#form-features').form('get validation', element);
              if (test) {
                //console.log('Removing rules for field = ' + field.name);
                data.push(field.name);
              }

            });
            if (data && data.length > 0) {
              $('#form-features').form('remove fields', data);
            }
          }
        }

        /**
         * Test for specified organization feature
         */
        function checkFeature(feature) {
          if ($scope.featureList) {
            let foundFeature = $scope.featureList.find(f => f.id === feature);
            if (foundFeature) {
              return foundFeature.checked;
            }
          }
          return false;
        }

        function saveSettings() {
          // Validate online website URL
          if (checkFeature('w')) {
            $('#form-features').form('validate form');
            if (!$('#form-features').form('is valid')) {
              $scope.loading = false;
              return false;
            }
          }

          $scope.loading = true;
          return $q.all([
            updateOrgFeaturesAndDeviceTypes(),
            saveOrgProperties(),
          ])
            .then(() => {
              $scope.loading = false;
              initOrganizationSettingsModel();
              ToastsService.success();
            })
            .catch(err => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function updateOrgFeaturesAndDeviceTypes() {
          let bDeviceTypes = false;
          let oldOrgDeviceTypes = $scope.orgDeviceTypeIds;
          let deviceTypes = $scope.helpers.selectedDeviceTypeIds && $scope.helpers.selectedDeviceTypeIds.sort().join(',');
          if (oldOrgDeviceTypes && deviceTypes) {
            let oldStr = oldOrgDeviceTypes.split(',').sort().join(',');
            if (oldStr === deviceTypes) { //not change
              bDeviceTypes = true;
            }
          }

          let bFeatures = false;
          let oldFeatures = $scope.organization.features;
          let featuresArr = [];
          let newFeaturesArr = [];
          for (let i = 0; i < $scope.featureList.length; i++) {
            let f = $scope.featureList[i];
            newFeaturesArr.push(f.id);
            if (f.checked) {
              featuresArr.push(f.id);
            }
          }

          // Diff features by @Max (fix for CC-300)
          let oldFeaturesArr = oldFeatures ? oldFeatures.split(',') : [];
          Array.prototype.diff = function(a) {
            return this.filter(function(i) {
              return a.indexOf(i) < 0;
            });
          };
          let featureDiff = oldFeaturesArr.diff(newFeaturesArr);
          featuresArr = featuresArr.concat(featureDiff);

          let features = featuresArr.sort().join(',');
          if (oldFeatures && features) {
            let oldStr = oldFeatures.split(',').sort().join(',');
            if (oldStr === features) { // not change
              bFeatures = true;
            }
          }

          if (bFeatures
            && bDeviceTypes
            && $scope.organization.initUserStatus === $scope.helpers.selectedInitUserStatusId
            && $scope.organization.initInviteeStatus === $scope.helpers.selectedInitInviteeStatusId) {
            return $q.when({
              resultCode: 0
            });
          }

          let updateData = {};
          if (!bFeatures) {
            updateData.features = features;
          }

          if (!bDeviceTypes) {
            updateData.deviceTypes = deviceTypes;
          }

          if ($scope.organization.initUserStatus !== $scope.helpers.selectedInitUserStatusId) {
            updateData.initUserStatus = $scope.helpers.selectedInitUserStatusId;
          }
          if ($scope.organization.initInviteeStatus !== $scope.helpers.selectedInitInviteeStatusId) {
            updateData.initInviteeStatus = $scope.helpers.selectedInitInviteeStatusId;
          }

          return $scope.dataProvider.saveOrganizationInfo(updateData)
            .then(() => {
              // Trigger refresh menu
              $rootScope.$emit('refreshMenusEvent');
            });
        }

        function saveOrgProperties() {
          let orgProps = [];
          ORGANIZATION_PROPERTIES.forEach(propName => {
            orgProps.push({
              name: propName,
              value: $scope.helpers[propName]
            });
          });

          let additionalProps = [
            {
              name: ORGANIZATION_USER_TAGS_PROPERTY,
              value: ($scope.helpers.selectedUserTags && $scope.helpers.selectedUserTags.join(',') || '')
            },
            {
              name: ORGANIZATION_LOCATION_TAGS_PROPERTY,
              value: ($scope.helpers.selectedLocationTags && $scope.helpers.selectedLocationTags.join(',') || '')
            },
            {
              name: ORGANIZATION_AVANTGUARD_DND_PROPERTY,
              value: $scope.helpers.agDnd
            },
            {
              name: ORGANIZATION_SIM_CARD_ACTIVATION_PROPERTY,
              value: $scope.helpers.orgSimCard === '1' ? '1' : ''
            },
          ];

          additionalProps.forEach(el => orgProps.push(el));
          return $scope.dataProvider.saveOrganizationProps(orgProps);
        }

        function goToObjects() {
          $scope.dataProvider.activeTab = 'objects';
        }

      }
    };
  })
  .name;
